import {
  Box, Container, Typography,
} from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import UseTranslation from '../../../hooks/UseTranslation'
import AccessDeniedImg from '../../../images/AccessDenied.svg'
import ResponsiveAppBar from '../../../components/ResponsiveAppBar'
import { isNotEmpty, objNotEmpty } from '../../../utils/helpers'
import CookiesStorageService from '../../../services/CookiesStorageService'
import { userAuthTokenDecode } from '../../../redux/features/userAuth/userAuthThunk'
import { selectAuthUser } from '../../../redux/features/userAuth/userAuthSlice'
import OfoqThemeBtn from '../../../components/Buttons/OfoqThemeBtn'

const AccessDenied = () => {
  const { t } = UseTranslation()
  const { authorizedUser } = useSelector(selectAuthUser)
  const isUserNotAuth = !objNotEmpty(authorizedUser)
  const dispatch = useDispatch()

  const umFrontEndPath = '/'

  const redirectToAuthPage = () => {
    window.location.href = `${umFrontEndPath}`
  }

  useEffect(() => {
    if (!objNotEmpty(authorizedUser) && isNotEmpty(CookiesStorageService.getAccessToken())) {
      dispatch(userAuthTokenDecode({ queries: { token: CookiesStorageService.getAccessToken() } }))
    }
  }, [])

  return (
    <Box sx={styles.root}>
      <ResponsiveAppBar onlyLogo={isUserNotAuth} />

      <Container maxWidth='xl' sx={styles.container}>
        <Box sx={styles.textWrapper}>
          <Typography sx={styles.errorTitle} variant="h1">
            {t?.['Access Denied !']}
          </Typography>
          <Typography variant="h3" sx={styles.errorSubTitle}>
            {t?.['Sorry but you are not authorized to view this page.']}
          </Typography>
          <Typography variant="p" sx={styles.errorDescription}>
            {t?.['It looks like you’ve tried to access a page that’s off-limits to you. Please make sure you have the right permissions.']}
          </Typography>
          <OfoqThemeBtn
          customStyle={styles.requestBtn}
          name={t?.['Move to Welcome Screen']}
          onClick={redirectToAuthPage}
        />
        </Box>
        <Box component="img" src={AccessDeniedImg} sx={styles.image} />
      </Container>
    </Box>
  )
}

const styles = {
  root: {
    paddingTop: '-20px',
  },
  container: {
    paddingInline: '0px !important',
    display: 'flex',
    flexDirection: { xs: 'column-reverse', md: 'row' },
    justifyContent: { xs: 'center', md: 'space-between' },
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: { xs: 'center', md: 'flex-start' },
    padding: { xs: '20px 10px 0 10px', md: '150px 0 0 80px' },
  },
  errorTitle: {
    color: 'primary.main',
    fontSize: { xs: '20px', sm: '30px', md: '50px' },
    lineHeight: '19px',
  },
  errorSubTitle: {
    fontSize: { xs: '14px', sm: '18px', md: '22px' },
    lineHeight: '25px',
    paddingTop: { xs: '20px', md: '70px' },
  },
  errorDescription: {
    fontSize: { xs: '12px', sm: '16px', md: '18px' },
    lineHeight: { xs: '20px', sm: '25px' },
    paddingTop: { xs: '10px', md: '30px' },
    color: '#92929D',
    textAlign: { xs: 'center', sm: 'left' },
  },
  image: {
    maxWidth: { xs: '200px', sm: '581px' },
    maxHeight: { xs: '200px', sm: '70vh' },
    marginInline: 'auto',
  },
  requestBtn: {
    maxWidth: { xs: '200px', md: '318px' },
    marginTop: { xs: '30px', md: '30px' },
    color: 'white',
    marginInline: { xs: 'auto', md: '0' },
    px: { xs: 3, md: 5 },
    textTransform: 'none',
  },
}

export default AccessDenied
